import { makeRequest, CommonRequestOptions } from '../makeRequest';

export type GetSingleEntryResponse = {
   entryid: number;
   guideid: number;
   userid: number;
   workorderid: string | null;
   starttime: number;
   endtime: number | null;
   max_form_revisionid: number | null;
   cancelled: boolean | null;
   guide_revisionid: number | null;
   handoffid: number | null;
   timingid: number;
   duration: number;
   status: 'paused' | 'completed' | 'cancelled' | 'started';
   active_duration: number;
   work_data: WorkData[] | [];
   signoffs: Signoffs[] | [];
   per_step_timing: PerStepTiming[];
   grouped_steps: GroupedSteps[];
};

export type Signoffs = {
   signoffid: number;
   stepid: number;
   entryid: number;
   userid: number;
   date: number;
   status: 'approved' | 'rejected';
   type: 'team';
   username: string;
   userProfile: string;
   userAvator: string;
   displayDate: string;
};

export type WorkData = {
   label: string;
   value: string;
   field_revisionid: number;
   stepid: number;
   step_number: number;
   field_type:
      | 'Checkbox'
      | 'Text Input'
      | 'Text Area'
      | 'Numeric Input'
      | 'Radios'
      | 'Select'
      | 'Image'
      | 'Video'
      | 'Document';
   image_src?: string;
   document_src?: string;
   document_filename?: string;
   video_data?: VideoData;
};

export type VideoData = {
   srcid: number | null;
   guid: string;
   imageid: number;
   active: boolean;
   type: 'GuideVideoObject' | 'GuideEmbedObject';
   video_urls: VideoUrls;
   mini: string;
   thumbnail: string;
   '140x105': string;
   '200x150': string;
   standard: string;
   '440x330': string;
   medium: string;
   large: string;
   huge: string;
   width: number;
   height: number;
   filename: string;
   view_url?: string;
   provider?: string;
};

export type VideoUrls = {
   mp4_720: string;
};

export type PerStepTiming = {
   stepid: number;
   time_estimate: number;
};

export type GroupedSteps = {
   signoffNumber: number;
   signoff: Signoffs | null;
   steps: Steps[];
};

export type Steps = {
   step_number: number;
   work_log: WorkData[] | [];
};

export async function getSingleEntry(
   entryid: number,
   { ...common }: CommonRequestOptions = {}
): Promise<GetSingleEntryResponse> {
   return makeRequest('get', `/work_log/${entryid}`, {
      ...common,
   });
}
